import { createFileRoute } from '@tanstack/react-router'

import { RewardsRootRoute } from '@/pages/rewards/route-entries/root-route'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/_private/app/rewards/')({
  component: RewardsRootRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Rewards Summary'),
        },
      ],
    }
  },
})
